/** Prefer `message`, fall back to legacy typo `mesasge`. */
export function apiMessage(data, fallback = "Something went wrong") {
  if (typeof data === "string" && data.trim()) return data;
  return data?.message || data?.mesasge || fallback;
}

export function listFailureMessage(status, serverMessage, resource = "this page") {
  if (!status) return "Unable to connect to the server.";
  if (status === 401) return "Your session has expired. Please sign in again.";
  if (status === 403) return `You don't have permission to view ${resource}.`;
  if (serverMessage && serverMessage !== "Internal server error") return serverMessage;
  return `Unable to load ${resource}.`;
}

/** Sign-in failures: show server text when present; reserve "connect" wording for true network faults. */
export function loginFailureMessage(err) {
	const data = err?.response?.data;
	if (err?.response) {
		const status = err.response.status;
		if (status === 429) {
			return "Too many sign-in attempts. Please wait a minute and try again.";
		}
		if (status >= 500) {
			return "The server is temporarily unavailable. Please try again shortly.";
		}
		return apiMessage(data, "Sign in failed. Check your email and password.");
	}
	if (err?.code === "ECONNABORTED") {
		return "The server took too long to respond. Please try again.";
	}
	const msg = String(err?.message || "");
	if (/network error/i.test(msg)) {
		return "Unable to reach the server. Check your connection and try again.";
	}
	return "Unable to connect to the server.";
}

const seen = new Map();

export function shouldShowToast(key, now = Date.now(), windowMs = 4000) {
  const previous = seen.get(key);
  if (previous && now - previous < windowMs) return false;
  seen.set(key, now);
  return true;
}

export function resetToastDedupe() {
  seen.clear();
}
